var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FEB91E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6809 29C17.3221 29 11.7697 28.7823 10.7172 26.9677C9.55594 24.8992 12.568 19.4919 13.5116 17.8589C14.4551 16.2621 17.7213 11 19.9713 11C22.5116 11 26.5398 17.7863 27.7374 20.1815C29.4793 23.6653 29.9874 25.9879 29.1527 27.0766C27.7737 28.9274 21.0237 29 19.6809 29ZM19.9713 12.4879C19.318 12.4879 17.1769 14.629 14.8543 18.621C12.3503 22.8669 11.6971 25.625 12.06 26.2419C12.3503 26.75 14.9632 27.5121 19.6809 27.5121C24.6164 27.5121 27.5197 26.7137 27.9188 26.1694C28.1729 25.8427 27.9551 24.1008 26.3584 20.871C23.9632 16.0806 20.8059 12.4879 19.9713 12.4879ZM20.0076 22.9032C19.5721 22.9032 19.2455 22.5766 19.2455 22.1411V16.371C19.2455 15.9355 19.5721 15.6089 20.0076 15.6089C20.443 15.6089 20.7697 15.9355 20.7697 16.371V22.1048C20.7697 22.5403 20.4067 22.9032 20.0076 22.9032ZM20.7697 24.8629C20.7697 25.2839 20.4285 25.625 20.0076 25.625C19.5866 25.625 19.2455 25.2839 19.2455 24.8629C19.2455 24.4419 19.5866 24.1008 20.0076 24.1008C20.4285 24.1008 20.7697 24.4419 20.7697 24.8629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon (3).74abf35b5c8b769ac6e52c7d420e08aa.svg";
export { ForwardRef as ReactComponent };